import { oneOfOrUndefined } from '@daymade/common-lib/types';
import { EntryMethod } from 'components/enter/EntryMethod';
import PageContent from 'components/enter/PageContent';
import MainLayout from 'components/layout/MainLayout';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next/types';
import { useEffect } from 'react';

const Enter = observer(
  ({
    redirectDestination,
    preselectedEntryMethod,
  }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    const { setEntryMethod } = useEnterStore();
    const router = useRouter();

    useEffect(() => {
      setEntryMethod(preselectedEntryMethod);
    }, [preselectedEntryMethod, setEntryMethod]);
    useEffect(() => {
      if (redirectDestination) {
        router.push(redirectDestination);
      }
    }, []);

    if (redirectDestination) {
      return <div></div>
    }

    return (
      <MainLayout>
        <NextSeo
          title="Online Contest | Your Chance to Win Epic Prizes | DAYMADE"
          description="Enter our online contests for your chance to win unbelievable prizes! How does brunch in Bali sound? And what about luxury breaks? Play today for just £2.95."
          openGraph={{
            title: 'Online Contest | Your Chance to Win Epic Prizes | DAYMADE',
            description:
              'Enter our online contests for your chance to win unbelievable prizes! How does brunch in Bali sound? And what about luxury breaks? Play today for just £2.95.',
          }}
        />
        <PageContent />
      </MainLayout>
    );
  }
);

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  // This query parameter is populated if user comes via home page entry method selector.
  const preselectedEntryMethodQueryParameter = ctx.query.em as string;
  const preselectedEntryMethod = oneOfOrUndefined(
    preselectedEntryMethodQueryParameter,
    ...Object.values(EntryMethod)
  );

  // Redirect to home page entry method selection if no preselected entry method.
  if (!preselectedEntryMethod) {
    const redirectUrl = ctx.resolvedUrl.replace('/enter', '/choose-your-plan'); // Redirect to home page keeping any query parameters
    return {
      props: {
        redirectDestination: redirectUrl,
      },
    };
  }

  return {
    props: {
      preselectedEntryMethod,
      shouldHideDrawDaysSelectorInFlow: false,
    },
  };
};

export default Enter;
